import { cn } from '@noor/lib/cn';
import type { DeliveryTone } from '../lib/status';

/** Dot fill per tone — the colored leading dot on each status-filter pill. */
const DELIVERY_DOT_CLASS: Record<DeliveryTone, string> = {
  sky: 'bg-delivery-sky',
  orange: 'bg-primary',
  neutral: 'bg-status-neutral',
  violet: 'bg-delivery-violet',
  pink: 'bg-delivery-pink',
  green: 'bg-delivery-green',
  red: 'bg-delivery-red',
};

interface DeliveryStatusDotProps {
  tone: DeliveryTone;
  className?: string;
}

/** An 8px colored dot — the leading marker on a status-filter pill. */
export function DeliveryStatusDot({ tone, className }: DeliveryStatusDotProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('size-2 shrink-0 rounded-full', DELIVERY_DOT_CLASS[tone], className)}
    />
  );
}
